<template>
    <BasePageHeader :title="t('journeys.header.title')" no-border>
        <template #subtitle>
            {{ t("journeys.header.subtitle") }}
        </template>
    </BasePageHeader>
</template>

<script setup lang="ts">
import BasePageHeader from "~vue/components/BasePageHeader.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
